import useSWR from "swr";
import useSWRFetcher from "./commonly-stored/fetcher";
import settings from "../../constants/settings";
import { dateStringToDate } from "../valueFormatting";

interface ShipDateResponse {
  ship_date: string;
}

function getRequestUrl(
  leadTimeDays: number,
  leadTimeStartDate: string | null = null,
): string | null {
  if (isNaN(leadTimeDays)) {
    return null;
  }
  const params = new URLSearchParams({
    lead_time_days: leadTimeDays.toString(),
  });
  if (leadTimeStartDate !== null) {
    params.set("lead_time_start_date", leadTimeStartDate);
  }
  return `${settings.api_url}/manufacturing/ship-date?${params.toString()}`;
}

// The ship date for a lead time starting now, or starting on
// `leadTimeStartDate` for a shipment whose lead time has already started.
export default function useGetShipDate(
  leadTimeDays: number,
  leadTimeStartDate: string | null = null,
) {
  const fetcher = useSWRFetcher<ShipDateResponse>();

  const { data } = useSWR<ShipDateResponse>(
    getRequestUrl(leadTimeDays, leadTimeStartDate),
    fetcher,
    {
      revalidateOnFocus: false,
    },
  );

  return {
    shipDate: data !== undefined ? dateStringToDate(data.ship_date) : null,
  };
}
